import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { colors } from '../../../styles/colors'
import { PrimaryButton } from '../../UI/PrimaryButton'
import { ProductInCart } from './ProductInCart'


const Container = styled.div`

    padding: 6.25rem;

    // INCLUDED CLASSES:

    .title {
        font-family: 'Lato', sans-serif;
        font-weight: 300;
        font-size: 3.75rem;
        line-height: 120%;
        letter-spacing: 0.05em;
        color: ${colors.dark_blue};

        margin-bottom: 6.25rem;

        @media (max-width: 320px) {
            margin: 0;
            margin-top: 5rem;
        }
    }

    .product-list {
        width: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;

        @media (min-width: 321px) and (max-width: 1359.98px) {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-around;
        }
        @media (max-width: 320px) {
            align-items: flex-start;
        }
    }

    .cart-empty {
        max-width: 50%;
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 120%;
        color: ${colors.dark_blue};

        @media (max-width: 600px) {
            max-width: 100%;
            margin: 5rem 0;
        }
    }

    .order-button{
        max-width: 260px;
        margin: 5rem auto;
    }

`

export const Cart = () => {
    
    const dispatch = useDispatch()
    const cart = useSelector(state => state.cart)

    function handleOrderButtonClick () {
        dispatch({ type: 'SET_INCOMING_ORDER_DATA', value: cart, order_type: 'PRODUCTS' })
        dispatch({ type: 'CONTACT_FORM_OPENED' })
    }

    return (
        <Container className='width-limiter'>
            <p className='title'>Корзина</p>

            <div className='product-list'>
                { cart.length !== 0
                    ? cart.map( (product, index) => (
                        <ProductInCart
                            picture={product.product_picture}
                            name={product.product_name}
                            count={product.count}
                            price={product.price}
                            index={index}
                            id={product.id}
                            key={product.id}
                        />
                    ))
                    : <p className='cart-empty'>Похоже вы пока еще ничего не добавили в корзину. Чтобы выбрать товары - воспользуйтесь строкой поиска или перейдите в <Link to='/products'>каталог</Link> </p>
                }
            </div>

            <PrimaryButton className="order-button" onClick={ handleOrderButtonClick } style={{ display: cart.length !== 0 ? 'block' : 'none' }} >Оформить заказ</PrimaryButton>


        </Container>
    )
}
